/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OneTimePasswordModel } from '../../models/one-time-password-model';

export interface GenerateTwoFactorKey$Params {
}

export function GenerateTwoFactorKey(http: HttpClient, rootUrl: string, params?: GenerateTwoFactorKey$Params, context?: HttpContext): Observable<StrictHttpResponse<OneTimePasswordModel>> {
  const rb = new RequestBuilder(rootUrl, GenerateTwoFactorKey.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OneTimePasswordModel>;
    })
  );
}

GenerateTwoFactorKey.PATH = '/api/Account/GenerateTwoFactorKey';
